module.exports = __webpack_public_path__ + "static/gallery13-bd185554a03be0d86567d2de7505232c.png";